import { useSelector } from 'react-redux'
import { State } from 'index'
import { getIsAdmin, getMails, getUid } from 'reducks/auth/selectors'
import { MailType, StaffType } from 'types/staff'
import { useEffect, useState } from 'react'

type UseHandleReceiveSetting = {
  mails: MailType[]
  uid: string
}

const useHandleReceiveSetting = (staff?: StaffType): UseHandleReceiveSetting => {
  const isAdmin = useSelector((state: State) => getIsAdmin(state))
  const authMails = useSelector((state: State) => getMails(state))
  const authUid = useSelector((state: State) => getUid(state))

  const [mails, setMails] = useState<MailType[]>([])
  const [uid, setUid] = useState<string>('')

  useEffect(() => {
    // スーパー管理者が操作している場合、対象メンバーのメール設定とuidを設定する
    if (isAdmin && staff) {
      setMails(staff.mails)
      setUid(staff.uid)
    } else {
      setMails([...authMails])
      setUid(authUid)
    }
  }, [isAdmin, staff, authMails, authUid])

  return {
    mails,
    uid,
  }
}

export default useHandleReceiveSetting
